// Containers — every bot container in one place:
//   LXCs            AudioSocket bot LXCs across all servers (admins)
//   Linux Machines  the old Linux bot system's machines (was /machines)
// The active tab is kept in ?tab= so links and refreshes land on it.
import { useSearchParams } from 'react-router-dom'
import { Boxes, Server, Monitor } from 'lucide-react'
import { useAuth } from '../context/AuthContext'
import { MachinesTab } from '../components/AudioSocketBotParts'
import Machines from './Machines'

const TABS = [
    { key: 'lxcs', label: 'LXCs', icon: Server, adminOnly: true },
    { key: 'linux', label: 'Linux Machines', icon: Monitor, access: 'access_to_machines' }
]

export default function Containers() {
    const { isAdmin, user } = useAuth()
    const [params, setParams] = useSearchParams()
    const allowed = TABS.filter(t =>
        t.adminOnly ? isAdmin : (isAdmin || !t.access || user?.[t.access]))
    const tab = allowed.find(t => t.key === params.get('tab'))?.key || allowed[0]?.key

    return (
        <div>
            <h1 className="tw-m-0 tw-mb-1.5 tw-flex tw-items-center tw-gap-2.5 tw-text-[22px]">
                <Boxes size={24} /> Containers
            </h1>
            <div className="tw-mb-4 tw-text-[13px] tw-text-muted">
                Bot containers across all servers — AudioSocket LXCs and the old Linux bot machines.
            </div>

            <div className="tw-mb-4 tw-flex tw-gap-1 tw-overflow-x-auto tw-border-0 tw-border-b tw-border-solid tw-border-border">
                {allowed.map(t => {
                    const I = t.icon
                    const active = tab === t.key
                    return (
                        <button key={t.key}
                            onClick={() => setParams({ tab: t.key }, { replace: true })}
                            className={`tw-flex tw-cursor-pointer tw-items-center tw-gap-1.5 tw-whitespace-nowrap tw-border-0 tw-border-b-2 tw-border-solid tw-px-4 tw-py-2.5 tw-text-sm ${
                                active
                                    ? 'tw-border-blue-500 tw-bg-card tw-font-semibold tw-text-fg'
                                    : 'tw-border-transparent tw-bg-transparent tw-font-normal tw-text-muted hover:tw-text-fg'
                            }`}>
                            <I size={16} /> {t.label}
                        </button>
                    )
                })}
            </div>

            {tab === 'lxcs' && <MachinesTab />}
            {tab === 'linux' && <Machines embedded />}
            {!tab && <div className="tw-opacity-60">You don't have access to any container lists.</div>}
        </div>
    )
}
